import { render, staticRenderFns } from "./RolesSelect.vue?vue&type=template&id=02a26efe&"
import script from "./RolesSelect.vue?vue&type=script&lang=js&"
export * from "./RolesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02a26efe')) {
      api.createRecord('02a26efe', component.options)
    } else {
      api.reload('02a26efe', component.options)
    }
    module.hot.accept("./RolesSelect.vue?vue&type=template&id=02a26efe&", function () {
      api.rerender('02a26efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/selects/RolesSelect.vue"
export default component.exports